import { Component } from '@angular/core';

@Component({
  selector: 'tasting-notes-icon',
  standalone: true,
  imports: [],
  templateUrl: './tasting-notes.component.html',
  styleUrl: './tasting-notes.component.scss'
})
export class TastingNotesIcon {}
